import React from "react";

const IsActiveModal = ({
  isOpen,
  onCancel,
  onConfirm,
  selectedLanguage,
  activeIsOpenEvent,
  activeIsOpenDocId,
  activeIsOpenHistoryFlag,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modalCus" id="myModal" style={{ zIndex: 1056 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="d-flex justify-content-center">
                <h4 className="mb-0 fw-bold font-20" htmlFor="">
                  <span
                    className="material-icons top3 "
                    style={{
                      fontSize: "400%",
                      color: "#3fa247",
                      marginTop: "25px",
                    }}>
                    info
                  </span>
                </h4>
                <button
                  type="button"
                  className="btn btn-outline-danger level3close modalclose download "
                  onClick={(e) => onCancel()}>
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="font-18 infoBody">
                {selectedLanguage.LstLanguageCodes.UI_validateActive}
              </div>
              <div className="pb-4 px-8 mt-4 d-flex flex-wrap justify-content-between">
                <button
                  type="button"
                  title={selectedLanguage.LstLanguageCodes.UI_Cancel}
                  className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                  data-bs-dismiss="modal"
                  onClick={(e) => onCancel()}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  title={selectedLanguage.LstLanguageCodes.UI_Confirm}
                  className="btn btn-primary px-2 ms-1 w-140p truncate"
                  onClick={(e) =>
                    onConfirm(
                      activeIsOpenEvent,
                      true,
                      activeIsOpenDocId,
                      activeIsOpenHistoryFlag,
                      true
                    )
                  }>
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
  );
};

export default IsActiveModal;
